// BGM + SFX 音效系统
import { S } from './state.js';

// ========== BGM 背景音乐 ==========
export const BGM_TRACKS = {
  lobby:     'assets/bgm_sera.mp3',
  forest:    'assets/bgm_forest.mp3',
  hetonmar:  'assets/bgm_hendon.mp3',
  sky_city:  'assets/bgm_skycastle.mp3',
  battle:    'assets/bgm_battle.mp3',
  default:   'assets/bgm_dnf.mp3',
};

export const bgm = document.getElementById('bgm');
bgm.volume = 0.12;
export let bgmOn = localStorage.getItem('dnf_bgm') !== 'off';
export let currentBGM = null;
export let bgmFadeTimer = null;

export function toggleBGM() {
  bgmOn = !bgmOn;
  localStorage.setItem('dnf_bgm', bgmOn ? 'on' : 'off');
  if(bgmOn) { bgm.play().catch(()=>{}); }
  else { bgm.pause(); }
  updateBgmButton();
}

export function tryAutoPlayBGM() {
  if(bgmOn) { bgm.play().catch(()=>{}); }
  updateBgmButton();
}

export function updateBgmButton() {
  const btn = document.getElementById('bgmBtn');
  if(btn) btn.textContent = bgmOn ? '🔊' : '🔇';
}

// ========== DNF 音效引擎（预加载真实mp3）==========
export const SFX_CACHE = {};
export const SFX_MANIFEST = [
  // 斩击
  'sfx_slash_heavy.mp3','sfx_slash_light.mp3','sfx_slash_fast.mp3',
  // 枪声/爆炸
  'sfx_gunshot.mp3','sfx_explosion.mp3',
  // 受击
  'sfx_hit_light.mp3','sfx_hit_heavy.mp3',
  // 怪物
  'sfx_monster_death.mp3',
  // 技能
  'sfx_skill_wave.mp3','sfx_skill_holy.mp3','sfx_skill_dark.mp3',
  // 武器击中
  'sfx_weapon_hit.mp3',
  // NPC语音(保留)
  'sera_raw.mp3','linas_raw.mp3',
  // 罐子系统
  'sfx_jar_open.mp3','sfx_treasure.mp3',
  // 土罐NPC语音(00663-00666)
  'npc_jarmerchant_1.mp3','npc_jarmerchant_2.mp3','npc_jarmerchant_3.mp3','npc_jarmerchant_4.mp3',
];

export function preloadAllSFX() {
  SFX_MANIFEST.forEach(f => {
    const a = new Audio(); a.preload = 'auto'; a.src = 'assets/' + f;
    a.load(); SFX_CACHE['assets/' + f] = a;
  });
}

export function playSFX(filename, vol) {
  let a = SFX_CACHE['assets/' + filename];
  if(!a) {
    // 预加载未完成，即时创建
    a = new Audio(); a.src = 'assets/' + filename;
    SFX_CACHE['assets/' + filename] = a;
  }
  a.volume = vol||0.5; a.currentTime = 0;
  a.play().catch(e => console.warn('SFX play failed:', filename, e.message));
}

let audioCtx = null;
export function initAudio() {
  if(!audioCtx) {
    try { audioCtx = new (window.AudioContext||window.webkitAudioContext)(); } catch(e){ return; }
  }
  // Chrome/Safari 需要在用户手势后 resume
  if(audioCtx.state === 'suspended') {
    audioCtx.resume().catch(()=>{});
  }
}

export function playNoise(type, dur, freq, vol) {
  initAudio(); if(!audioCtx) return;
  const t = audioCtx.currentTime;
  const g = audioCtx.createGain();
  g.gain.setValueAtTime(vol||0.15, t);
  g.gain.exponentialRampToValueAtTime(0.001, t+dur);
  g.connect(audioCtx.destination);
  if(type==='white') {
    const buf = audioCtx.createBuffer(1, audioCtx.sampleRate*0.3, audioCtx.sampleRate);
    const d = buf.getChannelData(0); for(let i=0;i<d.length;i++) d[i]=Math.random()*2-1;
    const s = audioCtx.createBufferSource(); s.buffer = buf;
    const f = audioCtx.createBiquadFilter(); f.type='bandpass'; f.frequency.value=freq||800; f.Q.value=0.5;
    s.connect(f); f.connect(g); s.start(t); s.stop(t+dur);
  } else if(type==='burst') {
    const o = audioCtx.createOscillator(); o.type='sawtooth'; o.frequency.value=freq||200;
    const f = audioCtx.createBiquadFilter(); f.type='lowpass'; f.frequency.value=400;
    o.connect(f); f.connect(g); o.start(t); o.stop(t+0.15);
  }
}

// === DNF 真实音效函数 ===
export function sfxSlash() { playSFX('sfx_slash_heavy.mp3',0.5); }
export function sfxHeavySlash() { playSFX('sfx_slash_heavy.mp3',0.65); }
export function sfxFastSlash() { playSFX('sfx_slash_fast.mp3',0.45); }
export function sfxGunShot() { playSFX('sfx_gunshot.mp3',0.5); }
export function sfxExplosion() { playSFX('sfx_explosion.mp3',0.55); }
export function sfxHit() { playSFX('sfx_hit_light.mp3',0.45); }
export function sfxHeavyHit() { playSFX('sfx_hit_heavy.mp3',0.5); }
export function sfxMonsterRoar() { playSFX('sfx_hit_heavy.mp3',0.3); /* 怪物攻击前摇-用重击代替 */ }
export function sfxMonsterDeath(monId) {
  const dieSfx = monId ? window.__monsterDieSfx?.[monId] : null;
  playSFX(dieSfx ? dieSfx+'.mp3' : 'sfx_monster_death.mp3', 0.55);
}
export function sfxEnergyWave() { playSFX('sfx_skill_wave.mp3',0.5); }
export function sfxHolyChime() { playSFX('sfx_skill_holy.mp3',0.5); }
export function sfxDarkEnergy() { playSFX('sfx_skill_dark.mp3',0.5); }
export function sfxWeaponHit() { playSFX('sfx_weapon_hit.mp3',0.4); }
export function sfxSeraWelcome() { if(S.scene === 'lobby') playSFX('sera_raw.mp3',0.8); }
export function sfxNPCSpeak(npcId) { 
  const voiceMap = {
    sera: ['npc_sera_tk_01.mp3','npc_sera_tk_02.mp3','npc_sera_tk_03.mp3'],
    gsd: ['npc_gsd_tk_01.mp3','npc_gsd_tk_02.mp3','npc_gsd_tk_03.mp3'],
    iris: ['npc_iris_tk_01.mp3','npc_iris_tk_02.mp3','npc_iris_tk_03.mp3'],
    blacksmith: ['npc_blacksmith_tk_01.mp3','npc_blacksmith_tk_02.mp3','npc_blacksmith_tk_03.mp3'],
    kiri: ['npc_kiri_tk_01.mp3','npc_kiri_tk_02.mp3','npc_kiri_tk_03.mp3'],
    grandis: ['npc_sera_tk_01.mp3','npc_sera_tk_02.mp3','npc_sera_tk_03.mp3'],
    norton: ['npc_blacksmith_tk_01.mp3','npc_blacksmith_tk_02.mp3','npc_blacksmith_tk_03.mp3'],
    jarmerchant: ['npc_jarmerchant_1.mp3','npc_jarmerchant_2.mp3','npc_jarmerchant_3.mp3','npc_jarmerchant_4.mp3'],
  };
  const files = voiceMap[npcId];
  if(files) { const f = files[Math.floor(Math.random()*files.length)]; playSFX(f, 0.7); }
}
export function sfxLevelUp() {
  initAudio(); if(!audioCtx) return;
  const t = audioCtx.currentTime;
  [262,330,392,523,659,784].forEach((f,i)=>{
    const g = audioCtx.createGain(); g.gain.setValueAtTime(0.06,t+i*0.07); g.gain.exponentialRampToValueAtTime(0.001,t+0.5);
    g.connect(audioCtx.destination);
    const o = audioCtx.createOscillator(); o.type='triangle'; o.frequency.value=f;
    o.connect(g); o.start(t+i*0.07); o.stop(t+0.5);
  });
}
export function sfxCoin() { playNoise('burst',0.04,1800,0.1); setTimeout(()=>playNoise('burst',0.04,2600,0.08), 40); }
export function sfxJarOpen() { playSFX('sfx_jar_open.mp3',0.5); }
export function sfxBtnClick() { playSFX('ui_click.mp3',0.3); }  // 改用DNF原版点击音效
// UI交互音效
export function sfxUIConfirm() { playSFX('ui_confirm.mp3',0.4); }
export function sfxUICancel() { playSFX('ui_cancel.mp3',0.4); }
export function sfxUIOpen() { playSFX('ui_open.mp3',0.4); }
export function sfxUIClose() { playSFX('ui_close.mp3',0.4); }
export function sfxUIBuy() { playSFX('ui_buy.mp3',0.35); }
export function sfxUIGold() { playSFX('ui_gold.mp3',0.35); }
export function sfxUIEquip() { playSFX('ui_equip.mp3',0.35); }
export function sfxUIDrop() { playSFX('ui_drop.mp3',0.35); }
export function sfxUISuccess() { playSFX('ui_success.mp3',0.45); }
export function sfxUIFail() { playSFX('ui_fail.mp3',0.4); }
export function sfxUINotice() { playSFX('ui_notice.mp3',0.3); }

// 职业攻击音效映射 - v2 音效+角色喊声
export function playClassAtkSound(cls, isSkill, skillType) {
  const cfg = window.COMBAT_SFX?.[cls];
  if(!cfg) { sfxSlash(); return; }
  if(!isSkill) {
    // 普攻：攻击音效
    const atkList = cfg.atk || [];
    if(atkList.length) playSFX(atkList[Math.floor(Math.random()*atkList.length)]+'.mp3', 0.5);
    else sfxSlash();
  } else {
    // 技能：专属特效音 + 短喊声
    const key = 'skill_'+ (skillType||'power');
    const sfxKey = cfg[key] || cfg.skill_power;
    if(sfxKey) playSFX(sfxKey+'.mp3', 0.6);
    if(cfg.shout_skill) {
      const ss = cfg.shout_skill;
      setTimeout(() => playSFX(ss[Math.floor(Math.random()*ss.length)]+'.mp3', 0.35), 60);
    }
  }
}

// 打击感：震动元素
export function shakeElement(el, intensity) {
  if(!el) return;
  el.style.transition = 'none';
  el.style.transform = `translateX(${(Math.random()-0.5)*intensity}px) translateY(${(Math.random()-0.5)*intensity}px)`;
  setTimeout(()=>{ el.style.transition='transform 0.12s ease-out'; el.style.transform='translateX(0) translateY(0)'; }, 25);
}
// 伤害数字弹出
export function showDmgNumber(el, dmg, color) {
  if(!el) return;
  const d = document.createElement('div');
  d.className = 'dmg-number';
  d.textContent = dmg;
  d.style.cssText = `position:absolute;color:${color||'var(--red)'};font-weight:900;font-size:${dmg>20?'20px':'15px'};pointer-events:none;z-index:50;left:${30+Math.random()*40}%;top:${20+Math.random()*20}%;animation:dmgFloat 0.8s ease-out forwards;text-shadow:0 0 4px currentColor;`;
  el.appendChild(d);
  setTimeout(()=>d.remove(), 800);
}
// 命中顿帧
export function hitStop(dur) {
  const c = document.getElementById('combatIllust');
  if(!c) return;
  c.style.animation = 'none'; c.offsetHeight;
  c.style.animation = `hitStop ${dur||60}ms steps(1)`;
}

export function switchBGM(sceneKey) {
  const track = BGM_TRACKS[sceneKey] || BGM_TRACKS.default;
  if(currentBGM === track) return;
  if(bgmFadeTimer) clearTimeout(bgmFadeTimer);
  if(!bgmOn) { currentBGM = track; return; }

  // 离开大厅时停止赛丽亚语音
  if(sceneKey !== 'lobby') {
    const seraAudio = SFX_CACHE['assets/sera_raw.mp3'];
    if(seraAudio) { seraAudio.pause(); seraAudio.currentTime = 0; }
  }

  // 区域音量：赫顿玛尔/Boss场景需要更大声
  if(sceneKey === 'battle') bgm.volume = 0.08;
  else if(sceneKey === 'hetonmar') bgm.volume = 0.20;
  else if(sceneKey === 'sky_city') bgm.volume = 0.15;
  else bgm.volume = 0.12;

  bgm.style.transition = 'opacity 0.6s';
  bgm.style.opacity = '0';

  bgmFadeTimer = setTimeout(() => {
    bgm.src = track;
    bgm.load();
    bgm.play().catch(()=>{});
    bgm.style.transition = 'opacity 0.8s';
    bgm.style.opacity = '1';
    currentBGM = track;
    bgmFadeTimer = null;
  }, 600);
}

export function resumeSceneBGM() {
  if(!S.scene || S.scene === 'lobby') switchBGM('lobby');
  else if(S.region) switchBGM(S.region);
  else switchBGM('default');
}